module.exports = __webpack_public_path__ + "img/hat-bg_11.4ab08991.png";